import Vue from 'vue'
import Header from './header'
import MyButton from './button'
import Picker from './picker'
import MyDatetimepicker from './datetimepicker'
Vue.use(Header).use(MyButton).use(Picker).use(MyDatetimepicker)



// WEBPACK FOOTER //
// ./src/components/index.js